module.exports = __webpack_public_path__ + "img/24 Michi mit Griller.jpg";